module.exports = {
	"101": "Facilities",
	"104": "Facilities",
	"105": "Facilities",
	"106": "Facilities",
	"107": "Facilities",
	"Alcazar, Lucas": "Information Technology",
	"Azada, Lars": "Engineering",
	"Balas, Felix": "Engineering",
	"Barranco, Ingrid": "Executive",
	"Baza, Isak": "Information Technology",
	"Bergen, Linnea": "Information Technology",
	"Bodrogi, Loreto": "Security",
	"Borrasca, Isande": "Engineering",
	"Calixto, Nils": "Information Technology",
	"Calzas, Axel": "Engineering",
	"Campo-Corrente, Ada": "Executive",
	"Cazar, Gustav": "Engineering",
	"Cocinaro, Hideki": "Security",
	"Dedos, Lidelse": "Engineering",
	"Ferro, Inga": "Security",
	"Flecha, Sven": "Information Technology",
	"Frente, Birgitta": "Engineering",
	"Frente, Vira": "Engineering",
	"Fusil, Stenig": "Security",
	"Herrero, Kanon": "Security",
	"Lagos, Varja": "Security",
	"Mies, Minke": "Security",
	"Nubarron, Adra": "Engineering",
	"Onda, Marin": "Engineering",
	"Orilla, Elsa": "Engineering",
	"Orilla, Kare": "Engineering",
	"Osvaldo, Hennie": "Security",
	"Ovan, Bertrand": "Facilities",
	"Resumir, Felix": "Security",
	"Sanjorge Jr., Sten": "Executive",
	"Strum, Orhan": "Executive",
	"Tempestad, Brand": "Engineering",
	"Vann, Edvard": "Security",
	"Vann, Isia": "Security",
	"Vasco-Pais, Willem": "Executive"
};


//////////////////
// WEBPACK FOOTER
// ./src/data/employees.json
// module id = 1005
// module chunks = 0